/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* Custom Header Menu */

  const headerTrigger = document.querySelector('[data-menu-dropdown-trigger]');
  const mainHeaderElement = document.querySelector(".header__mobile");

  // menu navigation item trigger
  headerTrigger.addEventListener("click", (event) => {
    mainHeaderElement.classList.contains("active")
      ? mainHeaderElement.classList.remove("active") 
      : mainHeaderElement.classList.add("active")
  });

  // close the menu if clicked outside
  document.addEventListener("click", (event) => {
    if(mainHeaderElement.classList.contains("active") && event.target.closest(".header__mobile") === null){
      mainHeaderElement.classList.remove("active");
    }
  });

  // set the opacity for each navigation item to create a gradient effect
  const numberOfItems = mainHeaderElement.querySelectorAll(".nav__item").length;
  const step = parseFloat((1 / numberOfItems).toFixed(2));
  let opacity = 1;

  mainHeaderElement.querySelectorAll(".nav__item").forEach((item) => {
    item.style.setProperty('--nav-item-opacity', opacity);
    opacity = opacity - step;
  });

  // trigger child items
  mainHeaderElement.querySelectorAll(".nav__item").forEach((item) => {
    const itemArrow = item.querySelector(".expand_child") || false;
    if(itemArrow){
      itemArrow.addEventListener("click", (event) => {
        event.preventDefault();
        event.target.querySelector("svg").classList.toggle("active");
        item.querySelector(".child-nav__item-list").classList.toggle("active");
      });

      const grandchildItems = item.querySelectorAll(".child-nav__item");
      grandchildItems.forEach((grandchild) => {
        const grandchildArrow = grandchild.querySelector(".expand_child") || false;

        if(grandchildArrow) {
          grandchildArrow.addEventListener("click", (event) => {
            event.preventDefault();
            event.target.querySelector("svg").classList.toggle("active");
            item.querySelector(".grandchild-nav__item-list").classList.toggle("active");
          });
        }
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
